// apps/accounts/src/pages/staff/StaffDashboard.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Calendar, Clock, Package, RefreshCw, AlertCircle, UserCheck } from 'lucide-react';
import pb from '../../lib/pocketbaseClient';
import { toast } from 'sonner';

export default function StaffDashboard() {
  const { user } = useAuth();
  const [todayAttendance, setTodayAttendance] = useState(null);
  const [stats, setStats] = useState({ totalMaterials: 0, lowStock: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const today = new Date().toISOString().split('T')[0];
      // 'attendance' ??????? ??????? ????, ?????? user = staff.id
      const att = await pb.collection('attendance').getFirstListItem(
        `user="${user.id}" && date="${today}"`,
        { requestKey: null }
      ).catch(() => null);
      setTodayAttendance(att);

      // ??????????? ????????
      const materials = await pb.collection('materials').getFullList({ requestKey: null });
      const low = materials.filter(m => m.current_stock < m.min_stock);
      setStats({ totalMaterials: materials.length, lowStock: low.length });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckIn = async () => {
    try {
      const today = new Date().toISOString().split('T')[0];
      const data = {
        user: user.id,
        date: today,
        checkIn: new Date().toISOString(),
        // status ????? ?? ????? ???? checkIn ???? ????
      };
      await pb.collection('attendance').create(data);
      toast.success('Checked In successfully');
      fetchData();
    } catch (err) {
      toast.error('Check-in failed: ' + err.message);
    }
  };

  const handleCheckOut = async () => {
    try {
      await pb.collection('attendance').update(todayAttendance.id, {
        checkOut: new Date().toISOString(),
      });
      toast.success('Checked Out successfully');
      fetchData();
    } catch (err) {
      toast.error('Check-out failed: ' + err.message);
    }
  };

  if (loading) return <div className="flex justify-center items-center h-64">Loading...</div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Staff Dashboard</h1>
        <p className="text-sm text-slate-500">Welcome back, {user?.name}</p>
      </div>
      
      {/* Attendance Card */}
      <Card className="bg-gradient-to-r from-emerald-50 to-white border-emerald-200">
        <CardContent className="p-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div>
              <p className="text-sm text-slate-500">Today's Status</p>
              <p className="text-2xl font-bold">
                {todayAttendance?.checkOut ? '? Completed' : 
                 todayAttendance?.checkIn ? '? Working' : '? Not Started'}
              </p>
              {todayAttendance?.checkIn && (
                <p className="text-sm text-slate-600">In: {new Date(todayAttendance.checkIn).toLocaleTimeString()}</p>
              )}
              {todayAttendance?.checkOut && (
                <p className="text-sm text-slate-600">Out: {new Date(todayAttendance.checkOut).toLocaleTimeString()}</p>
              )}
            </div>
            <div className="flex gap-2">
              {!todayAttendance?.checkIn && (
                <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={handleCheckIn}>
                  <Clock className="w-4 h-4 mr-1" /> Check In
                </Button>
              )}
              {todayAttendance?.checkIn && !todayAttendance?.checkOut && (
                <Button className="bg-red-600 hover:bg-red-700" onClick={handleCheckOut}>
                  <Clock className="w-4 h-4 mr-1" /> Check Out
                </Button>
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <Package className="w-8 h-8 text-blue-500" />
            <div><p className="text-xs text-slate-500">Total Materials</p><p className="text-xl font-bold">{stats.totalMaterials}</p></div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <AlertCircle className="w-8 h-8 text-amber-500" />
            <div><p className="text-xs text-slate-500">Low Stock Items</p><p className="text-xl font-bold text-amber-600">{stats.lowStock}</p></div>
          </CardContent>
        </Card>
      </div>

      {/* Quick Actions */}
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" onClick={() => window.location.href = '/staff/materials'}>
          <Package className="w-4 h-4 mr-1" /> Manage Materials
        </Button>
        <Button variant="outline" onClick={() => window.location.href = '/staff/stock'}>
          <RefreshCw className="w-4 h-4 mr-1" /> Update Stock
        </Button>
      </div>
    </div>
  );
}